import EntregasLista from "./EntregasLista"
import EntregasProvider from "./EntregasProvider"

const Entregas = () => {
  return (
    <EntregasProvider>
      <EntregasLista />
    </EntregasProvider>
  )
}

export default Entregas
